import * as React from 'react';
import clsx from 'clsx';
import * as types from 'src/types';
import { HowToAccessSlider } from './HowToAccessSlider';
import * as scss from './HowToAccess.module.scss';
import { StepType } from './Step';
import { VideoOverlay } from 'src/components/ui/videoOverlay/videoOverlay';

export type Props = {
  footer?: types.TextFields;
  headline?: types.TextFields;
  dataPhoneComputer: {
    headline: types.TextFields;
    items: StepType[];
  };
  dataTV: {
    headline: types.TextFields;
    items: StepType[];
  };
} & React.HTMLAttributes<HTMLElement>;

export const HowToAccess = ({
  className,
  footer,
  headline,
  dataPhoneComputer,
  dataTV,
  id,
  style,
}: Props) => {
  const [videoUrl, setVideoUrl] = React.useState<string | null>(null);
  const [overlayOpen, setOverlayOpen] = React.useState(false);
  const footerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!footerRef.current) return;

    // Only grab anchors that look "special"
    const specialLinks = footerRef.current.querySelectorAll<HTMLAnchorElement>(
      'a[href$=".m3u8"]'
    );

    setVideoUrl(specialLinks[0]?.href ?? null);

    const handleClick = (event: Event) => {
      event.preventDefault();
      setOverlayOpen(true);
    };

    specialLinks.forEach((link) => link.addEventListener('click', handleClick));
    return () => {
      specialLinks.forEach((link) =>
        link.removeEventListener('click', handleClick)
      );
    };
  }, []);

  return (
    <>
      <VideoOverlay
        title="Training Video"
        url={videoUrl ?? ''}
        open={overlayOpen}
        setOpen={setOverlayOpen} 
      />

      <section id={id} className={clsx(scss.wrapper, className)} style={style}>
        <div className={clsx(scss.header, 'container')}>
          <h2 style={headline?.style}>{headline?.text}</h2>
        </div>
        <HowToAccessSlider
          items={dataPhoneComputer.items}
          headline={dataPhoneComputer.headline.text} />
        <HowToAccessSlider items={dataTV.items} headline={dataTV.headline.text} />
        <div
          ref={footerRef}
          className={clsx(scss.footer, 'container')}
          dangerouslySetInnerHTML={{ __html: footer?.text ?? '' }}
        ></div>
      </section>
    </>
  );
};
